/** Client branding and public site URLs, from the client layer (vite.config.ts `define`). */
export const BRAND = __OPS_PORTAL__;

/** Width attribute for the client logo at a given height. */
export const logoWidth = (height: number) => Math.round(height * BRAND.aspectRatio);

/** Public marketing site (no trailing slash). Override with VITE_SITE_URL. */
export const SITE_URL: string = (
  import.meta.env.VITE_SITE_URL || (import.meta.env.MODE === "production" ? BRAND.siteUrls.production : BRAND.siteUrls.staging) || ""
).replace(/\/+$/, "");

export const siteLink = (path: string) => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
